import { useState } from 'react';

import type { TView } from '@shared/types/view';
import type { ColumnSizingState, Updater } from '@tanstack/react-table';

export const useColumnSizing = (view?: TView) => {
  const [columnSizing, setColumnSizing] = useState(
    view?.visible_static_fields.sizing || {}
  );

  const derivedColumnSizing = Object.keys(columnSizing || {}).length
    ? columnSizing
    : view?.visible_static_fields.sizing || {};

  function onColumnSizingChange(updaterOrValue: Updater<ColumnSizingState>) {
    if (typeof updaterOrValue === 'function') {
      const col = updaterOrValue(derivedColumnSizing);
      setColumnSizing(col);
    } else {
      setColumnSizing(updaterOrValue);
    }
  }

  return {
    columnSizing: derivedColumnSizing,
    onColumnSizingChange,
  };
};
